export const COLLAPSE = 'SIDER_COLLAPSE';
export const EXPAND = 'SIDER_EXPAND';
export const UPDATE_MENU = 'UPDATE_MENU_ITEMS';